import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";

/**
 * Reusable page banner with background image and breadcrumbs
 * Matches the exact markup from the original components
 * @param {boolean} param0.empty - Will render as a blank banner, but add a vertical spacer so content doesn't flow up past the navbar
 * @param {boolean} param0.dense - Will adjust padding for a more compact banner
 * @param {string} param0.bannerImage - URL of the background image
 * @param {string} param0.mainTitle - Main title of the page
 * @param {string} param0.pageTitle - Page title for breadcrumbs
 * @returns {JSX.Element}
 * @component
 */
const PageBanner = ({
  empty = false,
  dense = false,
  bannerImage,
  mainTitle = "",
  pageTitle,
}) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 765);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  // Use a safer style object with fallback for bannerImage
  const backgroundStyle = bannerImage
    ? { backgroundImage: `url('${bannerImage}')` }
    : {};

  const spacingStyle = empty
    ? { paddingTop: "120px", borderTop: "1px solid rgb(51, 51, 51)" }
    : dense
      ? { paddingTop: isMobile ? "20px" : "155px", paddingBottom: "10px" }
      : {};

  return empty ? (
    <div style={{ ...spacingStyle }}></div>
  ) : (
    <div
      className={"page-title-area"}
      style={{ ...backgroundStyle, ...spacingStyle }}
    >
      <div className="d-table">
        <div className="d-table-cell">
          <div className="container">
            <div className="page-title-content">
              <h2>{mainTitle}</h2>
              {pageTitle ? (
                <ul>
                  <li>
                    <Link to="/">Home</Link>
                  </li>
                  <li className="active">{pageTitle || mainTitle}</li>
                </ul>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
